<template>
  <ReportsPage
    :product="product"
    :product-data="productData"
    :forecast-subscription="forecastSubscription"
    :prices-assessment-subscription="subscription"
    :show-latest-report-section-in-price-assessments="true"
  >
    <NuxtPage
      :product="product"
      :product-data="productData"
      :forecast-subscription="forecastSubscription"
      :prices-assessment-subscription="subscription"
      :show-latest-report-section-in-price-assessments="true"
    />
  </ReportsPage>
</template>

<script setup lang="ts">
import {
  ANODE,
  MARKET,
  SUBSCRIPTION_FORECASTS_ANODE,
  SUBSCRIPTION_PRICE_ASSESSMENTS_ANODE,
} from '~/constants/services/constants'
import anodeData from '~/constants/data-reports/anode'
import ReportsPage from '~/components/market/ReportsPage.vue'

definePageMeta({ layout: 'services' })

const product = ref(ANODE)
const productData = ref(anodeData)
const forecastSubscription = ref(SUBSCRIPTION_FORECASTS_ANODE)
const subscription = ref(SUBSCRIPTION_PRICE_ASSESSMENTS_ANODE)

const { getSeoInfo } = useSeo()
const seo = getSeoInfo({
  title: `${MARKET.name}: ${ANODE.name} Data and Reports`,
})
useHead(seo)
</script>
